const GET_CONFIGURATION_REQUEST = 'platfi-ui-app/DASHBOARD/GET_CONFIGURATION_REQUEST';
const GET_CONFIGURATION_SUCCESS = 'platfi-ui-app/DASHBOARD/GET_CONFIGURATION_SUCCESS';
const GET_CONFIGURATION_FAILURE = 'platfi-ui-app/DASHBOARD/GET_CONFIGURATION_FAILURE';

export { GET_CONFIGURATION_REQUEST, GET_CONFIGURATION_SUCCESS, GET_CONFIGURATION_FAILURE };
